import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { appNavigationConstants, appNavigationConstants_Mobile } from "../../../utils/constants/header.constants";
import {
  MOBILE_ACCOUNTS_ROUTE,
  HOME_ROUTE,
  MOBILE_MENU_ROUTE,
  MY_PROFILE_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  CASINO_ROUTE,
  INT_CASINO_ROUTE,
  useAppSelector,
} from "@hypexone/uicore";
import {
  useAppDispatch,
  setCompetition,
  setEventType,
  SPORTS_MAP,
} from "@hypexone/uicore";
import { isDesktop, isMobile } from "react-device-detect";
import React, { useState } from "react";
import HeaderSearchInput from "./HeaderSearchInput";
import { IoIosSettings } from "react-icons/io";
import Languages from "../user-menu-pages/Languages";


interface SubHeaderProps {
  disableSportsSubheader?: boolean;
}
const SubHeader: React.FC<SubHeaderProps> = ({ disableSportsSubheader }) => {
  const pathName = useLocation().pathname;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { pathname, search } = location;
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);

  const isNavActive = (navigationUrl: string, defaultActive: boolean) => {
    if (navigationUrl.includes("?")) {
      return `${pathname}${search}` === navigationUrl;
    }

    if (navigationUrl === INT_CASINO_ROUTE && pathname === INT_CASINO_ROUTE) {
      const subProvider = new URLSearchParams(search).get("subProvider");
      if (
        subProvider &&
        ["FANTASY11", "RANDORA"].includes(subProvider.toUpperCase())
      ) {
        return false;
      }
    }

    return defaultActive;
  };

  const showNewTag = (item: { title: string; showNewTag?: boolean }) =>
    item.showNewTag || item.title === "Binary" || item.title === "Sportsbook";

  const [isMobileSearchPopupOpen, setIsMobileSearchPopupOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showSettings, setShowSettings] = useState(false);
  const [langSelected, setLangSelected] = useState<string>();

  const bgGradient =
    "bg-gradient-to-b from-[var(--subheader-tab-gradient-from)] to-[var(--subheader-tab-gradient-to)]";
  const activeTabBgGradient =
    "md:bg-gradient-to-b md:from-[var(--subheader-active-tab-gradient-from)] md:to-[60%] md:to-[var(--subheader-active-tab-gradient-to)]";

  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));
    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
  };
  const handleSettingClick = (e) => {
    e.preventDefault();
    const updatedState = { ...location.state, message: !showSettings };
    setShowSettings(!showSettings);
    navigate(location.pathname, { replace: true, state: updatedState });

  }
  const showSettingsTab =
    isDesktop &&
    /^\/exchange_sports\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(location.pathname);


  const excludedRoutes = [
    HOME_ROUTE,
    MOBILE_ACCOUNTS_ROUTE,
    MOBILE_MENU_ROUTE,
    MY_PROFILE_ROUTE,
    "/change-password",
  ];

  const excludeSubHeader =
    !excludedRoutes.includes(pathName) ||
    !pathName.startsWith(EXCHANGE_SPORTS_ROUTE);

  return (
    <div className="flex min-w-full font-bold text-[12px] md:bg-white text-white md:text-black">
      {isMobile && excludeSubHeader && (pathName == `${HOME_ROUTE}` ? true : disableSportsSubheader) && (
        <div className="flex w-full justify-center gap-[1px] bg-white">
          <div className="flex w-full items-center justify-center overflow-x-auto overflow-y-visible hide-scrollbar bg-black">
            <div className="flex items-center">
              {appNavigationConstants_Mobile.map(({ title, navigationUrl }, index) => (
                <NavLink
                  to={navigationUrl}
                  key={title}
                  className={({ isActive }) =>
                    `flex items-center justify-center text-nowrap border-r border-gray4 px-[10px] py-[7px] text-[14px] font-[400] text-white
          ${isActive ? "rounded-t-[8px] border-x border-t border-white bg-black1" : ""}`
                  }
                  onClick={() => handleNavLinkClick(title)}
                >
                  {title}
                </NavLink>
              ))}
              <div className="relative z-[60] shrink-0 overflow-visible border-l border-gray4 px-[10px] py-[7px]">
                <Languages
                  langSelected={langSelected}
                  setLangSelected={setLangSelected}
                  buttonColor="bg-black"
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobileSearchPopupOpen && (
        <div className="absolute bg-white p-2 top-0 w-full">
          <HeaderSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setIsMobileSearchPopupOpen={setIsMobileSearchPopupOpen}
          />
        </div>
      )}

      {isDesktop && <div className={`relative w-full ${activeTabBgGradient}`}>
        {<div className="flex overflow-x-auto overflow-y-visible hide-scrollbar pr-[80px]">
          {appNavigationConstants.map(({ title, navigationUrl, langKey, showNewTag: itemShowNewTag }) => (
            <NavLink
              to={navigationUrl}
              key={title}
              className={({ isActive }) => {
                const active = isNavActive(navigationUrl, isActive);

                return `hover:underline text-center text-xs py-[4px] text-nowrap px-3 mb-[2px] mt-[0.5px]
          border-r border-gray4 md:${bgGradient}
          ${title === "Fantasy11"
                  ? "animate-highlight"
                  : title === "Sportsbook"
                    ? "bg-color text-white"
                    : ""}
          ${title === "Multi Market" ? "bg-color" : ""}
          ${itemShowNewTag && !active ? "provider-new-nav-highlight" : ""}
          ${active
                  ? `underline underline-offset-4 md:no-underline md:${activeTabBgGradient}`
                  : ""}`;
              }}
              onClick={() => handleNavLinkClick(title)}
            >
              <div className="relative">
                {langData?.[langKey] ?? title}
                {showNewTag({ title, showNewTag: itemShowNewTag }) && (
                  <div className="absolute blink top-[-6px] right-[-20px] bg-red-500 text-white text-[8px] px-[2px] flex items-center justify-center">
                    {langData?.["new"] || "NEW"}
                  </div>
                )}
              </div>
            </NavLink>
          ))}
        </div>}

        {showSettingsTab && (
          <div
            onClick={(e) => handleSettingClick(e)}
            className="absolute top-0 gap-1 cursor-pointer right-0 h-full flex items-center bg-color text-white  px-2 py-[4px] mb-[2px] mt-[0.5px] border-l border-gray4 hover:text-blue-500"
          >
            <span className="transition-colors  text-[14px] font-[600]">Setting</span>
            <IoIosSettings className="w-4 h-4 mr-1 transition-colors" />
          </div>
        )}
      </div>}


    </div>
  );
};

export default SubHeader;
